import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import clsx from 'clsx';
import {
  Button,
  Card,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from '@material-ui/icons/Search';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import Header from '../headers/Header';
import Footer from '../footer/Footer';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 30px',
    marginBottom: '50px',
    padding: '20px 20px'
  },
  mainTable: {
    margin: '20px 0 20px'
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center'
  },
  backBtn: {
    background: 'var(--gmi-color)',
    width: '100px',
    "&:hover": {
      backgroundColor: '#113e78ec'
    },
    color: 'white'
  },
  editBtn: {
    background: 'var(--gmi-color)',
    "&:hover": {
      backgroundColor: '#113e78ec'
    },
    color: 'white',
    minInlineSize: 'auto',
    padding: '5px'
  },
  divider: {
    backgroundColor: 'var(--gmi-color)',
    height: '5px',
    margin: '10px 0'
  },
  search: {
    verticalAlign: 'baseline'
  },
  searchIc: {
    color: 'var(--search-icon)'
  },
  searchErr: {
    color: 'red',
    fontSize: '0.8em',
    marginLeft: '15px',
    [theme.breakpoints.down('xs')]: {
      display: 'grid',
      margin: '10px auto 15px',
    }
  },
  container: {
    maxHeight: 440
  },
  isAtt : {
    backgroundColor: 'var(--btn-green)',
    color: 'white',
    borderRadius: '5px',
    padding: '5px 8px'
  },
  isNotAtt: {
    backgroundColor: 'var(--btn-grey)',
    color: 'white',
    borderRadius: '5px',
    padding: '5px 8px'
  }
}));

const columns = [
  { id: "attributed", label: "Att", minWidth: 20, align: "center" },
  { id: "uuid", label: "UUID", minWidth: 50, align: "center" },
  { id: "console-sn", label: "Console S/N", minWidth: 50, align: "center" },
  { id: "end-user-id", label: "End user ID", minWidth: 50, align: "center" },
  { id: "console-type", label: "Console type", minWidth: 50, align: "center" },
  { id: "customer", label: "Customer", minWidth: 50, align: "center" },
  { id: "workshop", label: "Workshop", minWidth: 50, align: "center" },
  { id: "edit", label: "", minWidth: 50, align: "center" }
];

// const fakeData = [
//   {isAttributed: true, uuid: '1', console_nickname: 'EZ-001', console_id: 'A40-001', console_type: 'V1.0', cust_main_name: 'SIAEC', wsp_name: 'Changi'},
//   {isAttributed: true, uuid: '2', console_nickname: 'EZ-002', console_id: 'A40-002', console_type: 'V2.0', cust_main_name: 'Air France', wsp_name: 'Orly'},
//   {isAttributed: false, uuid: '3', console_nickname: 'EZ-003', console_id: 'A40-003', console_type: 'V2.0', cust_main_name: 'British AirWaves', wsp_name: 'London'},
//   {isAttributed: false, uuid: '4', console_nickname: 'EZ-004', console_id: 'A40-004', console_type: 'V4.0', cust_main_name: 'Air China', wsp_name: 'Beijing'},
//   {isAttributed: true, uuid: '5', console_nickname: 'EZ-005', console_id: 'A40-005', console_type: 'V4.0', cust_main_name: 'China Southern', wsp_name: 'Shanghai Pudong'},
//   {isAttributed: true, uuid: '6', console_nickname: 'EZ-006', console_id: 'A40-006', console_type: 'V2.0', cust_main_name: 'Qatar Airways', wsp_name: 'Doha'},
//   {isAttributed: true, uuid: '7', console_nickname: 'EZ-007', console_id: 'A40-007', console_type: 'V2.2', cust_main_name: 'Royal Air Maroc', wsp_name: 'Rabat'},
//   {isAttributed: true, uuid: '8', console_nickname: 'EZ-008', console_id: 'A40-008', console_type: 'V2.0', cust_main_name: 'Japan Airlines', wsp_name: 'Tokyo'},
//   {isAttributed: false, uuid: '9', console_nickname: 'EZ-009', console_id: 'A40-009', console_type: 'V2.2', cust_main_name: 'KLM', wsp_name: 'Amsterdam'},
//   {isAttributed: true, uuid: '10', console_nickname: 'EZ-0010', console_id: 'A40-010', console_type: 'V2.0', cust_main_name: 'Lufthansa', wsp_name: 'Berlin'},
//   {isAttributed: true, uuid: '11', console_nickname: 'EZ-0011', console_id: 'A40-0011', console_type: 'V2.2', cust_main_name: 'Etihad Airlines', wsp_name: 'Abu Dhabi'},
//   {isAttributed: false, uuid: '12', console_nickname: 'EZ-0012', console_id: 'A40-0012', console_type: 'V1.0', cust_main_name: 'Emirates', wsp_name: 'Dubai'},
//   {isAttributed: true, uuid: '13', console_nickname: 'EZ-0013', console_id: 'A40-0013', console_type: 'V4.0', cust_main_name: 'American Airlines', wsp_name: 'Washington DC'},
// ]

const AdminConsoles = ({ className, ...rest }) => {
  const classes = useStyles();
  const [consolesData, setConsolesData] = useState ([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const getCustomers = async () => {
      const result = await axios.get('http://cloud.gmi-aero.com:5000/console');
      setConsolesData(result.data);
    };
    getCustomers();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  const tableHeader =(
    columns.map((column) => (
      <TableCell
        key={column.id}
        align={column.align}
        style={{ minWidth: column.minWidth }}
      >
        {column.label}
      </TableCell>
    ))
  );

  const mainContent = (
    consolesData
      .filter(data => 
        Object.keys(data).some(key => 
          data[key] ? data[key].toLowerCase().includes(searchTerm.toLowerCase()) : data[key] === null ? null : null
        )
      )
      .map(consoles => {
        
        return (
          <TableRow
            key={consoles.uuid}
            hover
            role="checkbox"
            tabIndex={-1}
          >
            <TableCell
              component="th"
              scope="row"
              align="center"
            >
            {
              consoles.console_wsp_uuid
              ? (
                <Tooltip title="Console attributed" placement="right" arrow>
                  <span className={classes.isAtt}>V</span>
                </Tooltip>
              )
              : (
                <Tooltip title="Console not attributed" placement="right" arrow>
                  <span className={classes.isNotAtt}>X</span>
                </Tooltip>
              )
            }

            </TableCell>
            <Tooltip title={consoles.uuid} placement="right" arrow>
              <TableCell align="center">{consoles.uuid.slice(0,8).concat('...')}</TableCell>
            </Tooltip>
            <TableCell align="center">{consoles.console_id}</TableCell>
            <TableCell align="center">{consoles.console_nickname}</TableCell>
            <TableCell align="center">{consoles.console_type}</TableCell>
            <TableCell align="center">{consoles.cust_main_name}</TableCell>
            <TableCell align="center">{consoles.wsp_name}</TableCell>
            <TableCell align="center">
            <Link to={`/admin/consolesedit/${consoles.uuid}`}>
              <Tooltip title="Edit" placement="right">
                <Button className={classes.editBtn}>
                  <EditRoundedIcon />
                </Button>
              </Tooltip>
            </Link>
          </TableCell>
        </TableRow>
      );
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  );

  const filteredObj = (
    consolesData.filter(el => 
      Object.keys(el).some(key =>
        el[key] ? el[key].toLowerCase().includes(searchTerm.toLowerCase()) : el[key] === null ? null : null
      )
    )
  );

  return (
    <Fragment>
      <Header type={"admin"} />
      <div className={clsx(classes.pageContainer, className)}>
        <Card
          className={clsx(classes.root, className)}
          elevation={2}
          {...rest}
        >
          <Typography
            className={classes.title}
            gutterBottom
            variant="h4"
          >
            CONSOLE LIST
          </Typography>

          <TextField 
            className={classes.search}
            id="outlined-search" 
            label="Search" 
            type="search" 
            onChange={(e) => {
              setSearchTerm(e.target.value)
            }}
            autoComplete="off"
            InputProps={{
              endAdornment: 
              <InputAdornment position="end">
                <SearchIcon className={classes.searchIc} />
              </InputAdornment>
            }}
            />
          
          { filteredObj.length === 0 ? <span className={classes.searchErr}>No matching results</span> : null }

          <Divider className={classes.divider}/>

          <Grid>
            <Paper className={classes.mainTable}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  size="small"
                  aria-label="sticky table"
                >
                  <TableHead>
                    <TableRow>

                      { tableHeader }

                    </TableRow>
                  </TableHead>

                  <TableBody>
                    
                    { mainContent }

                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={filteredObj.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
          <Button className={classes.backBtn} href="/admin/dashboard"> &lt; Back</Button>
        </Card>
      </div>
      <Footer type="main"/>
    </Fragment>
  )
};

export default AdminConsoles;
